import React, { useEffect, useState ,useRef} from "react";
import { useLocation } from "react-router-dom";
import httpCommon from "../../http-common";
import Container from "../../component/Container";
import SearchForm from "../../component/search/search";
import AdvancedSearch from '../../component/searchBar/AdvancedSearch'
import Card from "../../component/card/PropertyCard";
import Social from "../../component/Social";
import { FaSellsy } from "react-icons/fa6";
import { MdAddHome } from "react-icons/md";
import { IoMdHappy } from "react-icons/io";
import { FaRegHandshake } from "react-icons/fa";
import Loader from "../../component/Loader/Loader";
import { Margin } from "@mui/icons-material";


function PropertyComponent({ defaultType }) {

    const limit = 20;
    const [allProperties, setAllProperties] = useState([]);
    const [originalProperties, setOriginalProperties] = useState([]);

    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);

    const [error, setError] = useState(null);

    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const [searchData, setSearchData] = useState(null);
    const loadMoreRef = useRef(null);
    const location = useLocation();

      const convertBudgetStringToNumber = (str) => {
        if (!str) return 0;

        // If the value is already a number, return as-is in rupees
        if (typeof str === 'number') return str * 100000; // Assuming number is in LAC

        const [amount, unit] = str.toUpperCase().split(" ");
        const num = parseFloat(amount);

        if (unit === "LAC" || unit === "LACS") return num * 100000;
        if (unit === "CR" || unit === "CRS") return num * 10000000;

        return num; // fallback
    };
console.log("allProperties____2",allProperties);
    // Fetch properties from the API
  //  const fetchAllProperties = async (filterParams = {}) => {
//const fetchAllProperties = async (filterParams = {}, searchData = null) => {
    const fetchAllProperties = async ({
        filterParams = {},
       pageNo = 1,
       searchData = null,
       isLoadMore = false,
     } = {}) => {

         if (isLoadMore) setLoadingMore(true);
        else setLoading(true);

        setError(null);
        const normalizeType = (value) => {
        return value?.toLowerCase().replace(/\s+/g, "");
        };

        try {
            
            const response = await httpCommon.get(`/list/all`, {
                params: { page: pageNo, limit, ...filterParams },
            });

          
             console.log(response, "response____AllProperties");

            if (response.data.status === "success") {
                const properties = response.data.data;
               // setOriginalProperties(properties);
              //  setAllProperties(properties);
               
                // if (properties.length < limit) {
                //         //setHasMore(false);
                //         setHasMore(response.data.data.length === limit);
                //     }
                  //  setHasMore(properties.length === limit);
                  //  setHasMore(response.data.data.length === limit);
                  if (isLoadMore) {
                setHasMore(properties.length === limit);
                } else {
                setHasMore(true); // reset when new search/filter
                }
              let filteredProperties = properties;

                const filterData = searchData || {};
               
                const minBudget = convertBudgetStringToNumber(filterData.minBudget);
                const maxBudget = convertBudgetStringToNumber(filterData.maxBudget);
                const locations = filterData.location || [];
                const propertyTypes = filterData.propertyType || [];
               // console.log("propertyTypes____",propertyTypes);
             
                const parsePrice = (priceStr) =>
                Number(priceStr?.replace(/[^\d.]/g, '')) || 0;

                filteredProperties = properties.filter((property) => {
                const price = parsePrice(property.ltg_det_sale_price);

                const matchesLocation =
                    !locations.length ||
                    locations.some((loc) =>
                     property.ltg_title?.toLowerCase().includes(loc.toLowerCase().trim())
                    );

                const matchesType =
                    !propertyTypes.length ||
                    propertyTypes.some((type) =>
                         normalizeType(property.ltg_type) === normalizeType(type)
                  //  property.ltg_type?.toLowerCase().trim() === type.toLowerCase().trim()
                    );

                const matchesBudget =
                    (!minBudget || price >= minBudget) &&
                    (!maxBudget || price <= maxBudget);

                return matchesLocation && matchesType && matchesBudget;

                }).sort((a, b) => {
                    // First: sort sold_type = 0 first, then sold_type = 1
                    if (a.ltg_det_sold_type !== b.ltg_det_sold_type) {
                    return a.ltg_det_sold_type - b.ltg_det_sold_type; // 0 before 1
                    }

                    // Second: within same sold_type, sort by date DESC (latest first)
                    return new Date(b.ltg_create_date) - new Date(a.ltg_create_date);
                });


              // console.log("filteredProperties___query list",filteredProperties);
        
              if (isLoadMore) {

              
                    setAllProperties((prev) => [...prev, ...filteredProperties]);
                    setOriginalProperties((prev) => [...prev, ...properties]);
                } else {
                    setAllProperties(filteredProperties);
                    setOriginalProperties(properties);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setError("Failed to fetch properties. Please try again.");
        } finally {
            setLoading(false);
             setLoadingMore(false);
        }
    };

    // Handle filter changes
    // const handleFilterChange = (formData) => {

    //     if (!formData || Object.keys(formData).length === 0) {
    //         setAllProperties(originalProperties);
    //         return;
    //     }
    //     // console.log("formData", formData);

    //     let filteredProperties = [...originalProperties] || [];

    //     if (filteredProperties.length === 0) {
    //         setAllProperties(filteredProperties);
    //         return;
    //     }

    //     if (formData.search && formData.search.trim() !== '') {
    //         filteredProperties = filteredProperties.filter((item) =>
    //             item.ltg_regions?.toLowerCase().includes(formData.search.toLowerCase()) ||
    //             item.ltg_categories?.toLowerCase().includes(formData.search.toLowerCase())
    //         );
    //     }

    //     if (formData.city && formData.city !== 'any') {
    //         filteredProperties = filteredProperties.filter((item) => {
    //             return item.ltg_regions?.toLowerCase() === formData.city.toLowerCase();
    //         });
    //     }

    //     if (formData.type && formData.type !== 'any') {
    //         filteredProperties = filteredProperties.filter((item) => {
    //             return item.ltg_categories?.toLowerCase() === formData.type?.toLowerCase();
    //         }
    //         );
    //     }

    //     const selectedProperty = formData.property || defaultType;

    //     if (formData.property && formData.property !== 'any') {
    //         filteredProperties = filteredProperties.filter((item) =>
    //             item.ltg_type === selectedProperty
    //         );
    //     }

    //     if (formData.price && (formData.price.min !== undefined || formData.price.max !== undefined)) {
    //         const minPrice = formData.price.min !== undefined ? formData.price.min : "";
    //         const maxPrice = formData.price.max !== undefined ? formData.price.max : "";

    //         filteredProperties = filteredProperties.filter((item) => {
    //             let salePrice = parseInt(getSalePrice(item), 10);
    //             return (
    //                 (minPrice === "" || salePrice >= minPrice) &&
    //                 (maxPrice === "" || salePrice <= maxPrice)
    //             );
    //         });
    //     }

    //     if (formData.area && (formData.area.min !== undefined || formData.area.max !== undefined)) {
    //         const minArea = formData.area.min !== undefined ? formData.area.min : "";
    //         const maxArea = formData.area.max !== undefined ? formData.area.max : "";

    //         filteredProperties = filteredProperties.filter((item) => {
    //             const area = parseInt(getArea(item), 10);
    //             return (
    //                 (minArea === "" || area >= minArea) &&
    //                 (maxArea === "" || area <= maxArea)
    //             );
    //         });
    //     }

    //     if (formData.bedRooms) {
    //         filteredProperties = filteredProperties.filter((item) => {
    //             const bedrooms = parseInt(getBedrooms(item), 10);
    //             return bedrooms >= parseInt(formData.bedRooms, 10);
    //         });
    //     }

    //     if (formData.bathRooms) {
    //         filteredProperties = filteredProperties.filter((item) => {
    //             const bathrooms = parseInt(getBathrooms(item), 10);
    //             return bathrooms >= parseInt(formData.bathRooms, 10);
    //         });
    //     }

    //     if (formData.status && formData.status !== 'any') {
    //         filteredProperties = filteredProperties.filter((item) => {
    //             const status = getStatus(item);
    //             return status?.toLowerCase() === formData.status?.toLowerCase();
    //         });
    //     }

    //     if (formData.amenities && formData.amenities.length > 0) {
    //         filteredProperties = filteredProperties.filter((item) => {
    //             const amenities = getAmenities(item);
    //             return formData.amenities.every((amenity) => amenities.includes(amenity));
    //         });
    //     }

    //     setAllProperties(filteredProperties);
    // };

    const getSalePrice = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_sale_price;
            case "PentHouses":
                return item.ltg_det_penthouses_sale_price;
            case "RowHouses":
                return item.ltg_det_row_house_sale_price;
            case "Plots":
                return item.ltg_det_plot_sale_price;
            case "Villaments":
                return item.ltg_det_villaments_sale_price;
            default:
                return item.ltg_det_sale_price;
        }
    };

    const getArea = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "RowHouses":
                return item.ltg_det_row_house_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "Plots":
                return item.ltg_det_plot_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "Villaments":
                return item.ltg_det_villaments_pmts_area_dts?.match(/(\d+)/)?.[0];
            default:
                return item.ltg_det_pmts_area_dts?.match(/(\d+)/)?.[0];
        }
    };

    const getBedrooms = (item) => {
        switch (item.ltg_type) {
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_bed_rooms;
            case "RowHouses":
                return item.ltg_det_row_house_pmts_bed_rooms;
            case "Villaments":
                return item.ltg_det_villaments_pmts_bed_rooms;
            default:
                return item.ltg_det_pmts_bed_rom;
        }
    };

    const getBathrooms = (item) => {
        switch (item.ltg_type) {
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_bath_rooms;
            case "RowHouses":
                return item.ltg_det_row_house_pmts_bath_rooms;
            case "Villaments":
                return item.ltg_det_villaments_pmts_bath_rooms;
            default:
                return item.ltg_det_pmts_bth_rom;
        }
    };

    const getStatus = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_pmts_status;
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_status;
            case "RowHouses":
                return item.ltg_det_row_house_pmts_status;
            case "Plots":
                return item.ltg_det_plot_pmts_status;
            case "Villaments":
                return item.ltg_det_villaments_pmts_status;
            default:
                return item.ltg_det_pmts_status;
        }
    };

    const getAmenities = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_amenities?.split(', ').map((amenity) => amenity.trim());
            case "PentHouses":
                return item.ltg_det_penthouses_amenities?.split(', ').map((amenity) => amenity.trim());
            case "RowHouses":
                return item.ltg_det_row_house_amenities?.split(', ').map((amenity) => amenity.trim());
            case "Plots":
                return item.ltg_det_plot_amenities?.split(', ').map((amenity) => amenity.trim());
            case "Villaments":
                return item.ltg_det_villaments_amenities?.split(', ').map((amenity) => amenity.trim());
            default:
                return item.ltg_det_amenities?.split(', ').map((amenity) => amenity.trim());
        }
    };

   
      useEffect(() => {
        if (location.state?.propertyType) return;
        const handler = setTimeout(() => {
            if (defaultType !== "") {
            setPage(1);
            setHasMore(true);
            fetchAllProperties({ pageNo: 1, searchData, isLoadMore: false });
            }
        }, 500);

        return () => clearTimeout(handler);
        }, [defaultType]);

    const handleAdvanceSearch = (data) => {
        console.log("Advanced Search Data from Property page:", data);
        // Update the filtering with new search data
        setSearchData(data);
        setPage(1);
        setHasMore(true);

       fetchAllProperties({ pageNo: 1, searchData: data, isLoadMore: false });
       // fetchAllProperties({}, data);
    };
  //  infinite scroll intersection observer
useEffect(() => {
  if (!hasMore || loadingMore) return;

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        const nextPage = page + 1;

        setPage(nextPage);

        fetchAllProperties({
          pageNo: nextPage,
          searchData,
          isLoadMore: true,
        });
      }
    },
    { rootMargin: "150px" } // smoother pre-load
  );

  if (loadMoreRef.current) {
    observer.observe(loadMoreRef.current);
  }

  return () => observer.disconnect();

}, [page, hasMore, loadingMore, searchData]);




  useEffect(() => {
  if (location.state?.propertyType) {

    const propertyTypeFromHeader = location.state.propertyType;
   // console.log("propertyTypeFromHeader____",propertyTypeFromHeader);
    const autoSearchData = {
      propertyType: [propertyTypeFromHeader],
      location: [],
      minBudget: "",
      maxBudget: "",
      projectTitle: []
    };

    setSearchData(autoSearchData);
    setPage(1);
    setHasMore(true);

    fetchAllProperties({
      pageNo: 1,
      searchData: autoSearchData,
      isLoadMore: false
    });

  }
}, [location.state]);

    return (
        <>
            <Container>
                {/* <SearchForm
                    onFilterChange={handleFilterChange}
                    defaultProperty={defaultType}
                /> */}
              <div style={{ margin: "25px 0px 6px 0px" }}>
                 <AdvancedSearch
                    propertyTypes={["Apartments", "Villas", "Plots", "Row Houses", "Villaments", "Commercial Properties", "Pent Houses"]}
                    budgets={[5, 10, 20, 30, 40, 50, 75, 100, 200, 300, 400, 500, 750, 1000, 1500, 2000]}
                     onSearch={handleAdvanceSearch}
                     
                />
                </div>
                {/* {loading ? <Loader /> : (
                    allProperties.map((item) => (
                         <Card key={item.RowID} item={item} />
                        
                    ))
                )} */}
                <div 
                style={{ 
                    position: "relative",
                    minHeight: "600px",   // reserve space so footer never jumps
                }}
                >

                {/* Properties always stay mounted */}
                {allProperties.map((item) => (
                <Card key={item.RowID} item={item} />
                ))}

                {/* Scroll trigger */}
                {hasMore && (
                <div ref={loadMoreRef} style={{ height: "40px" }} />
                )}

                {/* Loader (initial + scroll) */}
               {(loading || loadingMore) && (
                <div
                    style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "0",
                    right: "0",
                    display: "flex",
                    justifyContent: "center",
                    pointerEvents: "none",
                    }}
                >
                    <Loader />
                </div>
                )}

                {/* No more records */}
                {!hasMore && !loading && (
                <div
                    style={{
                    textAlign: "center",
                    margin: "15px 0",
                    fontWeight: "bold",
                    }}
                >
                    No more records
                </div>
                )}

            </div>

            {/* Error */}
            {error && (
                <p style={{ color: "red", marginTop: "10px" }}>
                {error}
                </p>
            )}

            </Container>

            {/* ===== FOOTER SECTION (NO JUMP NOW) ===== */}
            <section className="footerPatner bg-[#1C1C1E]">
            <Container
                className="md:py-20 flex flex-col md:flex-row items-center justify-between"
            >
                <div className="w-full left md:w-1/2 md:pr-10">
                <h2 className="mb-4 text-4xl font-bold text-white md:text-5xl">
                    More than 10 Years of Experience
                </h2>
                <hr className="w-20 h-1 mb-4 bg-blue-800" />
                <p className="text-white">
                    It’s not what we do, but how we do it that sets us apart. Get in
                    touch with us today to experience our holistic services that will
                    put you a step closer to your dream home.
                </p>
                </div>

                <div className="grid w-full grid-cols-1 mt-10 right md:w-1/2 md:grid-cols-2 gap-7 md:mt-0">

                <div className="flex items-center gap-5">
                    <FaSellsy className="text-blue-700" size={42} />
                    <div>
                    <h2 className="text-white price">3500 +</h2>
                    <p className="text-white description">Properties Sold</p>
                    </div>
                </div>

                <div className="flex items-center gap-5">
                    <MdAddHome className="text-blue-700" size={42} />
                    <div>
                    <h2 className="text-white price">230 +</h2>
                    <p className="text-white description">Projects Handled</p>
                    </div>
                </div>

                <div className="flex items-center gap-5">
                    <IoMdHappy className="text-blue-700" size={42} />
                    <div>
                    <h2 className="text-white price">400 +</h2>
                    <p className="text-white description">NRI Clients Served</p>
                    </div>
                </div>

                <div className="flex items-center gap-5">
                    <FaRegHandshake className="text-blue-700" size={42} />
                    <div>
                    <h2 className="text-white price">40 +</h2>
                    <p className="text-white description">
                        Builders, Marketing Partners
                    </p>
                    </div>
                </div>

                </div>
            </Container>

            <hr />
            </section>

            <Social />
        </>
    );
}

export default PropertyComponent;
